// src/components/FormNavigationButtons.js
import React from "react";
import {
  Save,
  Loader2,
  ArrowLeft,
  ChevronsRight,
  SendHorizonal,
} from "lucide-react";

function FormNavigationButtons({
  onBack,
  onNext,
  handleSaveOnly,
  handleSaveAndContinue,
  isEditable,
  isChanged,
  saving,
  fallbackUsed,
  // New props for step control
  currentStep, // e.g., 1, 2, 3...
  totalSteps, // e.g., 3, 5, etc.
}) {
  // Logic for the Next button's disabled state (from previous discussion)
  const isNextDisabled = saving || (isEditable && isChanged && !fallbackUsed);

  // Determine button visibility based on step
  const showBackButton = currentStep > 1;
  const showNextButton = currentStep < totalSteps;

  return (
    <div
      className={`flex flex-wrap gap-4 justify-between sm:justify-end ${
        currentStep === totalSteps ? "" : "mt-8"
      }`}
    >
      {showBackButton && ( // Conditionally render Back button
        <button
          type="button"
          onClick={onBack}
          disabled={saving}
          className="flex items-center gap-2 px-6 py-2 rounded-lg bg-gray-200 text-gray-800 hover:bg-gray-300 transition duration-200 cursor-pointer"
        >
          <ArrowLeft className="w-4 h-4" />
          Back
        </button>
      )}

      {isEditable && (
        <button
          type="button"
          onClick={handleSaveOnly}
          disabled={!isChanged || saving}
          className={`flex items-center gap-2 px-6 py-2 rounded-lg transition duration-200 ${
            saving || !isChanged
              ? "bg-gray-400 cursor-not-allowed"
              : "bg-blue-600 hover:bg-blue-700 text-white cursor-pointer"
          }`}
        >
          {saving ? (
            <Loader2 className="animate-spin w-4 h-4" />
          ) : (
            <Save className="w-4 h-4" />
          )}
          Save
        </button>
      )}

      {isEditable && (
        <button
          type="button"
          onClick={handleSaveAndContinue}
          disabled={!isChanged || saving}
          className={`flex items-center gap-2 px-6 py-2 rounded-lg transition duration-200 ${
            saving || !isChanged
              ? "bg-gray-400 cursor-not-allowed"
              : "bg-green-600 hover:bg-green-700 text-white cursor-pointer"
          }`}
        >
          {saving ? (
            <Loader2 className="animate-spin w-4 h-4" />
          ) : currentStep === totalSteps ? (
            <SendHorizonal className="w-4 h-4" />
          ) : (
            <Save className="w-4 h-4" />
          )}
          {currentStep === totalSteps ? "Submit Form" : "Save & Continue"}
        </button>
      )}

      {showNextButton && ( // Conditionally render Next button
        <button
          type="button"
          onClick={onNext}
          disabled={isNextDisabled}
          className={`flex items-center gap-2 px-6 py-2 rounded-lg transition duration-200 ${
            isNextDisabled
              ? "bg-gray-300 cursor-not-allowed"
              : "bg-purple-600 hover:bg-purple-700 text-white cursor-pointer"
          }`}
        >
          <ChevronsRight className="w-4 h-4" />
          Next
        </button>
      )}
    </div>
  );
}

export default FormNavigationButtons;
